@if (windowMode()) {
  @if (displayName(); as name) {
    <span
      data-testid="backoffice-kunde"
      class="flex items-center gap-2 min-w-0 max-w-full h-9 md:h-10 px-3 md:px-4 rounded-lg border-[1.5px] border-cp-primary-100 bg-white text-xs md:text-sm font-bold text-cp-primary-100"
    >
      <span class="min-w-0 truncate">{{ name }}</span>
      <mat-icon svgIcon="cp-person" class="!w-4 !h-4 md:!w-5 md:!h-5 shrink-0" />
    </span>
  }
} @else if (isLoggedIn()) {
  <button
    type="button"
    data-testid="account-menu-trigger"
    class="flex items-center gap-2 min-w-0 max-w-full h-9 md:h-10 px-3 md:px-4 rounded-lg border-[1.5px] border-cp-primary-100 bg-white text-xs md:text-sm font-bold text-cp-primary-100 disabled:opacity-50"
    [disabled]="loggingOut()"
    [matMenuTriggerFor]="accountMenu"
  >
    <span class="min-w-0 truncate">{{ displayName() ?? 'Eingeloggt' }}</span>
    <mat-icon svgIcon="cp-person" class="!w-4 !h-4 md:!w-5 md:!h-5 shrink-0" />
  </button>
  <mat-menu
    #accountMenu="matMenu"
    xPosition="before"
    class="!min-w-[10.5rem] !mt-2 [--mat-menu-container-shape:6px] [--mat-menu-container-elevation-shadow:0_2px_8px_rgba(0,0,0,0.12)] [--mat-menu-item-label-text-size:14px] [--mat-menu-item-label-text-weight:400] [--mat-menu-item-label-text-tracking:normal] [--mat-menu-item-label-text-color:var(--cp-primary-100)] [--mat-menu-item-hover-state-layer-color:var(--cp-primary-8)] [--mat-menu-item-focus-state-layer-color:var(--cp-primary-8)] [--mat-menu-item-leading-spacing:12px] [--mat-menu-item-trailing-spacing:12px] [&_.mat-mdc-menu-content]:!p-1"
  >
    <a
      mat-menu-item
      [href]="portalDashboardUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="!min-h-10 !rounded !no-underline"
    >
      Zum Kundenportal
    </a>
    <button mat-menu-item class="!min-h-10 !rounded" (click)="logout()">Logout</button>
  </mat-menu>
} @else {
  <button mat-stroked-button class="btn-secondary-sm btn-square !border-[1.5px]" (click)="login()">
    <span class="lg:hidden">Login</span>
    <span class="hidden lg:inline">Login Kundenportal</span>
  </button>
}
